export enum MovimentacaoTipo {
  CLASSIFICACAO = 'CLASSIFICACAO',
  TRANSFERENCIA = 'TRANSFERENCIA',
  DESIGNACAO = 'DESIGNACAO',
  INATIVIDADE = 'INATIVIDADE',
  DESLIGAMENTO = 'DESLIGAMENTO',
}

export const MovimentacaoTipoLabel: Record<MovimentacaoTipo, string> = {
  [MovimentacaoTipo.CLASSIFICACAO]: 'Classificação',
  [MovimentacaoTipo.TRANSFERENCIA]: 'Transferência',
  [MovimentacaoTipo.DESIGNACAO]: 'Designação',
  [MovimentacaoTipo.INATIVIDADE]: 'Inatividade',
  [MovimentacaoTipo.DESLIGAMENTO]: 'Desligamento',
};

export enum MovimentacaoStatus {
  MINUTA = 'MINUTA',
  EFETIVADA = 'EFETIVADA',
  CANCELADA = 'CANCELADA',
}

export const MovimentacaoStatusLabel: Record<MovimentacaoStatus, string> = {
  [MovimentacaoStatus.MINUTA]: 'Minuta',
  [MovimentacaoStatus.EFETIVADA]: 'Efetivada',
  [MovimentacaoStatus.CANCELADA]: 'Cancelada',
};

export const MovimentacaoStatusColor: Record<MovimentacaoStatus, string> = {
  [MovimentacaoStatus.MINUTA]: 'bg-amber-100 text-amber-700',
  [MovimentacaoStatus.EFETIVADA]: 'bg-green-100 text-green-700',
  [MovimentacaoStatus.CANCELADA]: 'bg-red-100 text-red-700',
};

export enum DesligamentoTipo {
  VOLUNTARIO = 'VOLUNTARIO',
  ADMINISTRATIVO = 'ADMINISTRATIVO',
  DISCIPLINAR = 'DISCIPLINAR',
  SAUDE = 'SAUDE',
  TEMPO_SERVICO = 'TEMPO_SERVICO',
  OBITO = 'OBITO',
}

export const DesligamentoTipoLabel: Record<DesligamentoTipo, string> = {
  [DesligamentoTipo.VOLUNTARIO]: 'Voluntário (A Pedido / Licenciamento)',
  [DesligamentoTipo.ADMINISTRATIVO]: 'Administrativo (Conveniência)',
  [DesligamentoTipo.DISCIPLINAR]: 'Disciplinar (Exclusão / Demissão)',
  [DesligamentoTipo.SAUDE]: 'Saúde (Reforma / Invalidez)',
  [DesligamentoTipo.TEMPO_SERVICO]: 'Término de Tempo de Serviço',
  [DesligamentoTipo.OBITO]: 'Falecimento',
};

export enum RequerimentoStatus {
  PENDENTE_CMT = 'PENDENTE_CMT',
  PENDENTE_DP = 'PENDENTE_DP',
  DEFERIDO = 'DEFERIDO',
  INDEFERIDO = 'INDEFERIDO',
}

export const RequerimentoStatusLabel: Record<RequerimentoStatus, string> = {
  [RequerimentoStatus.PENDENTE_CMT]: 'Pendente Parecer Cmt',
  [RequerimentoStatus.PENDENTE_DP]: 'Pendente Decisão DP',
  [RequerimentoStatus.DEFERIDO]: 'Deferido',
  [RequerimentoStatus.INDEFERIDO]: 'Indeferido',
};

export const RequerimentoStatusColor: Record<RequerimentoStatus, string> = {
  [RequerimentoStatus.PENDENTE_CMT]: 'bg-amber-100 text-amber-700',
  [RequerimentoStatus.PENDENTE_DP]: 'bg-blue-100 text-blue-700',
  [RequerimentoStatus.DEFERIDO]: 'bg-green-100 text-green-700',
  [RequerimentoStatus.INDEFERIDO]: 'bg-red-100 text-red-700',
};

export interface MovimentacaoResumo {
  id: string;
  matricula: string;
  nomePolicial: string;
  postoGraduacao: string;
  tipo: MovimentacaoTipo;
  unidadeOrigemId: string | null;
  unidadeOrigemNome: string | null;
  unidadeDestinoId: string | null;
  unidadeDestinoNome: string | null;
  dataEntrada: string;
  numeroSei: string | null;
  status: MovimentacaoStatus;
  responsavelNome: string;
}

export interface MovimentacaoDetalhe extends MovimentacaoResumo {
  publicacaoDodf: string | null;
  dataPublicacaoDodf: string | null;
  motivo: string;
  observacoes: string | null;
  manterPerfilSistema: boolean;
  tipoDesligamento?: DesligamentoTipo;
  documentoComprobatorioUrl?: string;
  dataCriacao: string;
}

export interface MovimentacaoCreate {
  matricula: string;
  tipo: MovimentacaoTipo;
  unidadeDestinoId: string | null;
  dataEntrada: string;
  numeroSei?: string;
  publicacaoDodf?: string;
  motivo: string;
  observacoes?: string;
  manterPerfilSistema: boolean;
  tipoDesligamento?: DesligamentoTipo;
  documentoComprobatorio?: File;
}

export interface MovimentacaoLoteCreate {
  matriculas: string[];
  unidadeDestinoId: string;
  dataEntrada: string;
  numeroSei?: string;
  motivo: string;
  observacoes?: string;
}

export interface RequerimentoTransferencia {
  id: string;
  policialId: string;
  matricula: string;
  nomePolicial: string;
  postoGraduacao: string;
  comportamento: string;
  unidadeOrigemId: string;
  unidadeOrigemNome: string;
  unidadeDesejadaId: string;
  unidadeDesejadaNome: string;
  motivoJustificativa: string;
  parecerChefiaOrigem: string | null;
  parecerChefiaOrigemPor: string | null;
  parecerChefiaDestino: string | null;
  parecerChefiaDestinoPor: string | null;
  decisaoDp: string | null;
  decisaoDpPor: string | null;
  statusWorkflow: RequerimentoStatus;
  dataCriacao: string;
  anexoUrl: string | null;
}

export interface RequerimentoCreate {
  unidadeDesejadaId: string;
  motivoJustificativa: string;
  documentoAnexo?: File;
}

export interface TramitarRequerimento {
  parecer: string;
  deferido: boolean;
}

export interface PainelClaros {
  unidadeId: string;
  unidadeNome: string;
  cargoPosto: string;
  vagasPrevistas: number;
  efetivoAtual: number;
  deficitSuperavit: number;
  percentualRestricoes: number;
}

export interface EstatisticasMovimentacao {
  saldoEfetivoPeriodo: number; // Entradas - Saídas
  totalClarosGeral: number;
  clarosPorOpm: {
    unidadeNome: string;
    vagasPrevistas: number;
    efetivoAtual: number;
    deficitSuperavit: number;
  }[];
  perfilSexo: {
    sexo: 'M' | 'F';
    quantidade: number;
    percentual: number;
  }[];
  perfilIdade: {
    faixa: string; // "18-25", "26-35", "36-45", "46+"
    quantidade: number;
    percentual: number;
  }[];
  distribuicaoHierarquica: {
    grupo: 'OFICIAIS' | 'PRACAS';
    postoGraduacao: string;
    quantidade: number;
  }[];
  motivosDesligamento: {
    tipo: DesligamentoTipo;
    quantidade: number;
  }[];
  alertasCriticos: {
    unidadeId: string;
    unidadeNome: string;
    tipoAlerta: 'DEFICIT_CRITICO' | 'RESTRICAO_CRITICA';
    mensagem: string;
    valor: number; // percentual de deficit ou restrição
  }[];
}

export interface PageMovimentacaoResumo {
  content: MovimentacaoResumo[];
  totalElements: number;
  totalPages: number;
  page: number;
  size: number;
}

export interface MovimentacaoFiltros {
  matricula?: string;
  unidadeOrigemId?: string;
  unidadeDestinoId?: string;
  tipo?: MovimentacaoTipo;
  status?: MovimentacaoStatus;
  dataInicio?: string;
  dataFim?: string;
}
